import RedrawService from '@/services/RedrawService';
import MapService from '@/services/MapService';
import store from '@/store';
import NotificationService from '@/services/NotificationService';

export interface IUseManualMapUpdate {
  handleRefreshData: () => void,
}
const useManualMapUpdate = (): IUseManualMapUpdate => {
  const handleRefreshData = () => {
    const redrawService = new RedrawService(new MapService(store.state.leafletMapInstance));

    redrawService.updateAndRedraw()
      .then(() => {
        NotificationService.success('Aktualizacja danych', 'Pomyślnie zakutalizowano punkty na mapie.');
      });
  };

  return {
    handleRefreshData,
  };
};

export default useManualMapUpdate;
